/**
 * Escape PLP color dots — select ring + sticky image preview on product-card.
 * ponytail: leave returns to selected media (not gallery initial) so click sticks.
 */
const DOT = ".es-pcard__colors .es-pcard__color-dot";

function selectDot(btn) {
  const row = btn.closest(".es-pcard__colors");
  if (!row) return;
  row.querySelectorAll(DOT).forEach((el) => {
    el.classList.remove("is-selected");
    el.setAttribute("aria-pressed", "false");
  });
  btn.classList.add("is-selected");
  btn.setAttribute("aria-pressed", "true");
}

function preview(card, mediaId) {
  if (!card || !mediaId || typeof card.previewVariant !== "function") return;
  card.previewVariant(mediaId);
}

function previewSelected(card, row) {
  const selected = row?.querySelector(`${DOT}.is-selected[data-media-id]`);
  if (selected?.dataset.mediaId) {
    preview(card, selected.dataset.mediaId);
    return;
  }
  if (typeof card.resetVariant === "function") card.resetVariant();
}

document.addEventListener("click", (event) => {
  const btn = event.target.closest?.(DOT);
  if (!(btn instanceof HTMLElement)) return;

  event.preventDefault();
  event.stopPropagation();
  selectDot(btn);

  const card = btn.closest("product-card");
  if (btn.dataset.mediaId) preview(card, btn.dataset.mediaId);
});

document.addEventListener("pointerover", (event) => {
  const btn = event.target.closest?.(DOT);
  if (!(btn instanceof HTMLElement) || !btn.dataset.mediaId) return;
  if (event.relatedTarget instanceof Node && btn.contains(event.relatedTarget)) return;

  const card = btn.closest("product-card");
  preview(card, btn.dataset.mediaId);
});

document.addEventListener("pointerout", (event) => {
  const btn = event.target.closest?.(DOT);
  if (!(btn instanceof HTMLElement)) return;
  if (event.relatedTarget instanceof Node && btn.contains(event.relatedTarget)) return;

  const row = btn.closest(".es-pcard__colors");
  if (event.relatedTarget instanceof Node && row?.contains(event.relatedTarget)) return;

  const card = btn.closest("product-card");
  if (!card) return;
  previewSelected(card, row);
});

